<template>
  <div>
  <v-container fluid class="pl-15 pr-10">
    <div class="d-flex justify-end mt-5">
      <v-btn
        depressed
        light
        @click="openLicenceWindow()"
      >
        <v-icon color="titleText">mdi-license</v-icon>
        <span class="titleText--text text-capitalize font-weight-bold ml-2">License</span>
      </v-btn>
    </div>
          <div class="table-container" role="table" aria-label="Destinations">
            <div class="d-flex" role="rowgroup">
              <div
                class="flex-row header font-weight-bold titleText--text"
                role="columnheader"
                v-for="title in headers"
                :key="title.text"
                :style="{width: title.width + 'em', 'margin-left': title.ml + '%'}"
              >
                {{ title.text }}
              </div>
            </div>
            <v-card
              class="d-flex justify-start align-center row mb-2 py-4 pl-8 custom-shadow"
              role="rowgroup"
              v-for="(item) in itemList" :key="item.id"
              min-height="54"
              elevation="0"
              :ripple="false"
            >
              <div class="cell first titleText--text font-weight-bold" style="width: 15%">{{ item.username }}</div>
              <div class="cell" style="width: 17%">{{ item.loginid }}</div>
              <div class="cell" style="width: 15%; opacity: 1;"> 
                <div v-if="item.Guest">
                  <v-icon color="#2CD8C5">mdi-checkbox-marked</v-icon>
                </div></div>
              <div class="cell" style="width: 20%">
               {{ item.Application }}
              </div>
              <div class="cell ml-5" style="width: 10%; opacity: 1;">
                <div v-if="item.isactive">
                        <v-icon color="#2CD8C5">mdi-checkbox-marked</v-icon>
                      </div>
              </div>
              <div class="cell d-flex justify-end" style="opacity: 1;">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      light
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="showEditdilog(item.id)" class="cursor_pointer">
                      <v-list-item-icon class="mr-0">
                        <v-icon small color="titleText">mdi-pencil-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title class="titleText--text font-weight-bold">
                         Edit
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openUserDataMappingWindow(item.id, item.username)">
                      <v-list-item-icon class="mr-0">
                        <v-icon small color="titleText">mdi-account-check-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title class="titleText--text font-weight-bold">
                         Access settings
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showAlertConfirm(item.id)">
                      <v-list-item-icon class="mr-0">
                        <v-icon small color="red">mdi-trash-can-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title class="red--text font-weight-bold">
                         Delete
                        </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-card>
          </div>
        
          <!-- <div slot="widget-content">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left text-capitalize">#</th>
                    <th class="text-center text-capitalize">User Name</th>
                    <th class="text-center text-capitalize">Login Id</th>
                    <th class="text-center text-capitalize">Can Share</th>
                    <th class="text-center text-capitalize">
                      Application Name
                    </th>
                    <th
                      class="text-left text-capitalize"
                      style="width: 50px !important"
                    >
                      IsActive
                    </th>
                    <th class="text-center text-capitalize">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(items, index) in itemList" :key="items.id">
                    <td>{{ index + 1 }}</td>
                    <td class="text-center">{{ items.username }}</td>
                    <td class="text-center">{{ items.loginid }}</td>
                    <td class="text-center">
                      <div v-if="items.Guest">
                        <v-icon class="inactive-bg-green">mdi-check</v-icon>
                      </div>
                      <div v-else>
                        <v-icon class="inactive-bg">mdi-alpha-x</v-icon>
                      </div>
                    </td>
                    <td class="text-center">{{ items.Application }}</td>
                    <td>
                      <div v-if="!items.isactive">
                        <v-icon class="inactive-bg">mdi-alpha-x</v-icon>
                      </div>
                      <div v-else>
                        <v-icon class="inactive-bg-green">mdi-check</v-icon>
                      </div>
                    </td>

                    <td>
                      <v-btn
                        title="Edit User"
                        small
                        icon
                        @click="showEditdilog(items.id)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        title="Delete User"
                        small
                        icon
                        @click="showAlertConfirm(items.id)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        title="Change Password"
                        small
                        icon
                        @click="showEditdilogforpwd(items.id)"
                      >
                        <v-icon>mdi-account-key-outline</v-icon>
                      </v-btn>
                      <v-btn
                        title="Mapp Data"
                        small
                        icon
                        @click="openUserDataMappingWindow(items.id, items.username)"
                      >
                        <v-icon>mdi-database-eye</v-icon>
                      </v-btn>
                      <v-btn
                        title="Mapp Applications"
                        small
                        icon
                        @click="openappmapingdliog(items.id, items.username)"
                      >
                        <v-icon>mdi-application-brackets-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div> -->
    <CtrlLicence ref="ctrllicence"></CtrlLicence>
    <CtrlUserDataMapping ref="ctruserdatamapping" :id="userId" :name="userName"></CtrlUserDataMapping>
    <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="blue"
              fab
              fixed
              bottom
              right
              dark
              v-bind="attrs"
              v-on="on"
              @click="addnewitem()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-form ref="form" v-model="valid">
            <v-card color="#F3F5F8">
              <v-card-title>
                <h4 class="titleText--text">User settings</h4>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" icon @click="closeForm()">
                  <v-icon color="titleText">mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <div>
                    <h5 class="titleText--text ml-2">User name</h5>
                    <v-text-field
                      v-model="name"
                      :counter="50"
                      :rules="nameRules"
                      hide-details="auto"
                      required
                      solo
                      flat
                      style="border-radius: 8px; font-weight: bold; opacity: .6;"
                    ></v-text-field>
                  </div>
                  <div>
                    <h5 class="titleText--text ml-2">Login ID</h5>
                    <v-text-field
                      v-model="loginid"
                      :counter="200"
                      :rules="nameRules"
                      hide-details="auto"
                      required
                      solo
                      flat
                      style="border-radius: 8px; font-weight: bold; opacity: .6;"
                    ></v-text-field>
                  </div>
                  <div>
                    <h5 class="titleText--text ml-2">Password</h5>
                    <v-text-field
                      v-model="strpassword"
                      :counter="50"
                      hide-details="auto"
                      required
                      solo
                      flat
                      type="password"
                      style="border-radius: 8px; font-weight: bold; opacity: .6;"
                    ></v-text-field>
                  </div>
                  <div class="d-flex justify-start">
                    <v-checkbox v-model="isactive" color="#2CD8C5">
                      <template v-slot:label>
                        <span class="titleText--text font-weight-bold">Is active</span>
                      </template></v-checkbox>
                    <v-checkbox v-model="isGuest" color="#2CD8C5" class="ml-3">
                      <template v-slot:label>
                        <span class="titleText--text font-weight-bold">Can share</span>
                      </template>
                    </v-checkbox>
                  </div>
                </v-container>
                <v-btn
                    :disabled="!valid"
                    color="blue"
                    depressed
                    @click="addupdate()"
                    width="120"
                    class="ml-3"
                  >
                    <span class="font-weight-bold text-capitalize" :class="valid ? 'white--text' : 'titleText--text'">Save</span>
                  </v-btn>
              </v-card-text>
            </v-card>
          </v-form>
        </v-dialog>
  </v-container>
</div>
</template>

<script>
import CtrlLicence from "./ctrlViewLicence.vue";
import CtrlUserDataMapping from "./UserDataMapping.vue";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import apifactory from "../api";
Vue.use(VueAxios, axios);
export default {
  components: {
    CtrlLicence,
    CtrlUserDataMapping,
  },
  data() {
    return {
      dialog: false,
      valid: true,
      isShowpwd: true,
      itemListtbd: [],
      itemList: [],
      itemRole: "",
      userId: null,
      userName: null,

      name: "",
      strpassword: "",
      loginid: "",
      id: 0,
      roleid: "",
      isactive: true,
      isGuest: false,

      appusername: "manish",
      nameRules: [
        (v) => !!v || "This Field is required",
        (v) =>
          (v && v.length <= 100) || "Name must be less than 100 characters",
      ],

      listapps: [],
      selecteditemapp: [],
    };
  },
  mounted() {
    this.listapps = this.getallapps();
    this.getall();
  },
  computed: {
    headers() {
      return [
        {
          text: "User",
          filterable: true,
          value: "name",
          width: 180,
          ml: 1.5
        },
        {
          text: "Login ID",
          filterable: true,
          value: "brand",
          width: 200,
          ml: 2.5
        },
        {
          text: "Can Share",
          filterable: true,
          value: "country",
          width: 200,
          ml: 3
        },
        {
          text: "Application",
          filterable: true,
          value: "level",
          width: 270,
          ml: 4.5
        },
        {
          text: "Is Active",
          filterable: true,
          value: "modifiedon",
          width: 250,
          ml: 1
        },
        {
          text: "",
          filterable: true,
          value: "modifiedon",
          width: 250
        },
      ];
    },
  },
  methods: {
      openUserDataMappingWindow(id, name) {
        this.userId = id
        this.userName = name
        this.$refs.ctruserdatamapping.OnloadCall(id, name);
    },
    openLicenceWindow() {
      this.$refs.ctrllicence.OnloadCall();
    },
    reloadfromchild() {
      this.userId = this.userName = null
      this.getall();
    },
    getallapps() {
      apifactory
        .apicall_app()
        .then((res) => {
          if (res.status != 200) {
            this.listapps = null;
            // alert(this.processdataitems.length);
          } else {
            this.listapps = res.data.filter((a) => a.id != 5);
            // alert(res);
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    addnewitem() {
      console.log('valid', this.valid)
      this.valid = false
      this.isactive = true;
      this.isGuest = false;
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    closeForm() {
      this.reset();     
      this.isShowpwd = true;
      this.dialog = false;
    },

    showAlertConfirm(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.delete(id);
          this.$swal("Deleted!", "Your Data has been deleted.", "success");
        }
      });
    },
    addupdate() {
      if (this.$refs.form.validate()) {
        if (this.id != 0) {
          //this.isShowpwd = false;
          this.update();
        } else {
          //this.isShowpwd = true;
          this.addnew();
        }
      }
    },
    showEditdilog(id) {
      this.id = id;
      this.isShowpwd = false;
      this.getbyID(id);
    },
    showEditdilogforpwd(id) {
      this.id = id;
      this.isShowpwd = true;
      this.getbyID(id);
    },
    getall() {
      //alert('dd');
      //let ll=apibase.call

      apifactory
        .getall()
        .then((res) => {
         // alert(JSON.stringify(res));
          if (res.status != 200) {
            this.itemList = null;
            // alert(this.processdataitems.length);
          } else {
            this.itemList = res.data.userlist;
            // alert(res);
          }
        })
        .catch(function (error) {
         alert(JSON.stringify(error));
        });
    },
    getbyID(id) {
      apifactory
        .getbyid(id)
        .then((res) => {
         //alert(JSON.stringify(res));

          if (res.status != 200) {
            //this.countryList = null;
            // alert(this.processdataitems.length);
          } else {
            this.itemListtbd = res.data.userlist;
            //alert(JSON.stringify(this.itemListtbd));
            this.name = this.itemListtbd[0].username;
            this.loginid = this.itemListtbd[0].loginid;
            //this.roleid = res.data.role;
            this.isactive = this.itemListtbd[0].isactive;
            this.isGuest = this.itemListtbd[0].IsGuest;
            this.dialog = true;
            //this.itemRole= [{id: res.data.role, name: res.data.role__name}];
            /* this.itemRole = {
                            "id": res.data.role,
                            "name": res.data.role__name

                        };*/
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    update() {
      //  alert('this.isShowpwd' + this.isShowpwd);
      if (this.isShowpwd) {
        //alert(typeof(this.strpassword));
        if (typeof this.strpassword == "undefined") {
          //alert('Enter the new Pasword');
          this.$swal("Alert!", "Enter the new Pasword.", "error");
          return;
        }
        if (this.strpassword == null) {
          this.$swal("Alert!", "Enter the new Pasword.", "error");
          return;
        }
        // alert(this.strpassword);
      }
      //alert('Go Next');
      apifactory
        .update(
          this.id,
          this.name,
          this.loginid,
          this.isactive,
          this.strpassword,
          this.isShowpwd,
          this.isGuest
        )
        .then((res) => {
          //alert(JSON.stringify(res));

          if (res.status != 200) {
            //this.countryList = null;
            // alert(this.processdataitems.length);
          } else {
            this.id = 0;
            this.reset();
            this.dialog = false;
            this.getall();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    addnew() {
      //let apiurl = apifactory.countryAdd(this.countryName, this.currencyCode, "manish"); // "http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/country/?name=" + this.countryName + "&currencycode=" + this.currencyCode + "&isactive=" + this.isActive;
      //alert(this.itemRole.id);
      apifactory
        .addNew(
          this.name,
          this.strpassword,
          this.loginid,
          this.isactive,
          this.isGuest
        )
        .then((res) => {
          alert(JSON.stringify(res));

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.id = 0;
            this.reset();
            this.getall();
            this.dialog = false;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    delete(id) {
      //let apiurl = apifactory.countryDelete(id); // "http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/country/?id=" + id + "&isdisable=true";

      apifactory
        .delete(id)
        .then((res) => {
          // alert(res.status);

          if (res.status != 200) {
            //this.countryList = null;
            // alert(this.processdataitems.length);
          } else {
            // this.id = 0;
            //this.reset();
            this.getall();
            //this.dialog = false;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .cursor__pointer {
    cursor: pointer;
  }
  
  .flex-table {
    display: grid;
    grid-template-columns: repeat(auto-fill, 20%);
    grid-template-rows: 100% auto;
    transition: 0.5s;
  }
  
  .table-container {
    margin-left: 8px
  }
  
  .flex-row {
    display: block;
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
  }
  .row:first-child {
    color: #505D6F
  }
  
  .cell {
    font-size: 14px;
    font-weight: 500;
    color: #505D6F;
    opacity: .6;
    width: 20%;
  }
  
  .first {
    opacity: 1
  }
  
  .last {
    width: 200px !important;
    padding-left: 15px;
    opacity: 1
  }
  
  .second {
    width: 20% !important;
  }
  
  .header {
    font-size: 12px;
    font-weight: 500;
    color: #505D6F
  }
  
  .custom-shadow {
    box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important;
  }
  
  .custom-shadow:hover {
    box-shadow: 0px 16px 36px rgba(82, 111, 151, 0.06) !important;
    transform: scale(1.004);
    transition: all 0.2s ease-out;
  }
  
  .cursor__pointer {
    cursor: pointer
  }
  </style>
